import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { generateQueryParams } from "helpers/queryParams";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import { getForms, updateFormStatus } from "helpers/API Calls/System & Settings/Customar Forms";
import ConformationModal from "Components/Modals/ConformationModal";
import ModalWrapper from "Components/Modals/ModalWrapper";

const head = [
  { id: 0, name: "#", isSortable: true, key: "id" },
  { id: 1, name: "Name", isSortable: true, key: "name" },
  { id: 2, name: "Email", isSortable: true, key: "email" },
  { id: 3, name: "Date", isSortable: false, key: "date_of_event" },
  { id: 4, name: "Rating", isSortable: true, key: "rating" },
  { id: 6, name: "Booking", isSortable: true, key: "booking_id" },
  { id: 16, name: "Comments", isSortable: true, key: "comments" },
  { id: 5, name: "Status", isSortable: true, key: "status" },
  { id: 7, name: "Created", isSortable: true, key: "created_at" },
  { id: 8, name: "Updated", isSortable: true, key: "updated_at" },
  { id: 9, name: "Actions", isSortable: false, key: "actions" }
];

function Testimonials() {  
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});
  
    const [editModal, setEditModal] = useState<boolean>(false);
    const [viewModal, setViewModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    
    const { filters, updateFilter } = useTableFilters();
  
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getForms(generateQueryParams(filters) + "&type=feedback");
      if (response.success) {
        setData(response.data.items);
        setPagination(response.data.pagination);
      }
      setIsLoading(false);
    }
  
    useEffect(() => {
      fetchData();
    }, [filters]);
  
    const handleEditClick = (item) => {
      setSelectedItem(item);
      setEditModal(true);
    };

    const handleViewClick = (item) => {
      setSelectedItem(item);
      setViewModal(true);
    };
    
  
    const handleEditConfirm = async () => {
      if (selectedItem) {
        const response = await updateFormStatus(selectedItem.id, {status : selectedItem.status === 1 ? 0 : 1});
        if (response.success) {
          setEditModal(false);
          setSelectedItem(null);
          fetchData();
        }
      }
    };
  
    const onCloseClick = () => {
      setEditModal(false);
      setViewModal(false);
      setSelectedItem(null);
    };
  
  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: 'Testimonials' }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              isAddButton={true}
              buttonText="Add New Testimonial"
              to="create"
              > 
              {data.length > 0 && data.map((item) => (                
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td className="text-truncate">{item?.content?.name}</td>
                  <td className="text-truncate">{item?.content?.email}</td>
                  <td>{convertDateFormat(item?.content?.date_of_event)}</td>
                  <td>{item?.content?.rating}</td>
                  <td>
                    {item?.content?.booking_id ? 
                    <Link to={`/bookings/${item?.content?.booking_id}/edit`}>Booking-{item?.content?.booking_id}</Link>
                    :
                    '-'
                  }
                  </td>
                  <td className="text-truncate">{item?.content?.comments}</td>
                  <td>
                    <span className={`badge badge-soft-${item.status === 1 ? 'success' : 'danger'}`}>
                      {item.status === 1 ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <button className="btn btn-warning btn-sm me-1" onClick={() => handleViewClick(item)}><i className="mdi mdi-eye"></i></button>
                      <button className="btn btn-primary btn-sm" onClick={() => handleEditClick(item)}><i className="bx bx-pencil"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {editModal && 
    <ConformationModal
      show={editModal}
      onConfirmClick={handleEditConfirm}
      onCloseClick={onCloseClick}
      textBefore={'mark'}
      message={`"${selectedItem?.content?.name}"`}
      textAfter={selectedItem?.status === 1 ? 'testimonial as inactive' : 'testimonial as active'}
      buttonText= {selectedItem?.status === 1 ? 'Deactivate' : 'Activate'}
    />}
    {viewModal && <ModalWrapper
      show={viewModal}
      onCloseClick={onCloseClick}
      title={`Testimonial from ${selectedItem?.content?.name}`}
      body={
        <div>
          <p className="mb-1"><strong>Email:</strong> {selectedItem?.content?.email}</p>
          <p className="mb-1"><strong>Date of Event:</strong> {convertDateFormat(selectedItem?.content?.date_of_event)}</p>          <p className="mb-1"><strong>Rating:</strong> {selectedItem?.content?.rating}</p>
          <div className="mb-1">
            <strong>Comments:</strong>
            <div className="mt-2 p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', maxHeight: '200px', overflowY: 'auto' }}>
              {selectedItem?.content?.comments}
            </div>
          </div>
          <p className="mb-1"><strong>Booking ID:</strong><Link to={`/bookings/${selectedItem?.content?.booking_id}/edit`}>Booking-{selectedItem?.content?.booking_id}</Link></p>
        </div>
      }
    />}
    </>
  );
}

export default Testimonials;
